// ABOUTME: A count of forms holding edits nobody saved yet, so code that would reload the tab can ask.
// ABOUTME: Deliberately a module, not a context: the asker (the PWA updater) sits outside the tree.

let holds = 0

/** Whether any open form is holding edits the user has not saved. */
export const hasUnsavedWork = (): boolean => holds > 0

/**
 * Registers unsaved edits and returns the release for them.
 *
 * Released on unmount and when the form goes clean again; the returned function
 * is safe to call twice, because a double release would let a reload through
 * while another form is still dirty.
 */
export const holdUnsavedWork = (): (() => void) => {
  holds += 1
  let released = false

  return () => {
    if (released) return
    released = true
    holds -= 1
  }
}

/** Test seam: forget every hold. Never call this from the app. */
export const resetUnsavedWork = (): void => {
  holds = 0
}
